import $request from '../../../utils/request';
var state = {
    isLoanOrder: '',
    loanOrderList: [],
    totalItemCount: 0,
    pageSize: 20,
    pageNo: 1,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    // 获取贷款订单列表
    GET_ORDERLIST: function (_a, param) {
        var commit = _a.commit;
        $request({
            url: '/proxy/fund-api/capital/contract/list/lease',
            method: 'post',
            data: param,
        }).then(function (res) {
            if (!res || res.errorCode !== 0) {
                return;
            }
            var data = res.data, totalItemCount = res.totalItemCount, pageSize = res.pageSize, pageNo = res.pageNo;
            commit('update', {
                loanOrderList: data,
                totalItemCount: totalItemCount,
                pageSize: pageSize,
                pageNo: pageNo,
            });
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
